import React, { Component } from 'react'
import MaskedInput from 'react-text-mask'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { changeCashAttr } from '../../../actions/purchaseActions'
import ErrorMessage from '../error_message/ErrorMessage'


class HolderInfo extends Component {
    render() {
        return (
            <React.Fragment>
                <form className="flex">
                    <div className="input-form1">
                        <label htmlFor="" className="label-form">Responsável pelo pagamento</label>

                        <input
                            type="text"
                            name="holderName"
                            value={this.props.holderName}
                            onChange={this.props.handleChange}
                            placeholder="Nome completo"
                        />
                        <ErrorMessage anchor="holderName" field1="cash" field2="holderName" />
                    </div>
                    <div className="input-form1" >
                        <label htmlFor="" className="label-form">CPF</label>
                        <MaskedInput
                            name="holderCpf"
                            type="tel"
                            value={this.props.holderCpf}
                            onChange={this.props.handleChange}
                            placeholder="000.000.000-00"
                            mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                            guide
                        />
                        <ErrorMessage anchor="holderCpf" field1="cash" field2="holderCpf" />
                    </div>
                </form>
            </React.Fragment>
        )
    }
}

class Cash extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const field = {
            name: e.target.name,
            value: e.target.value,
        }

        this.props.changeCashAttr(field);
    }

    render() {
        return (
            <div className="area-dinheiro">

                <HolderInfo
                    handleChange={this.handleChange}
                    username={this.props.username}
                    holderName={this.props.holderName}
                    holderCpf={this.props.holderCpf}
                />

            </div>
        )
    }
}

export default withRouter(connect(
    state => ({
        username: state.purchase.cash.username,
        password: state.purchase.cash.password,
        holderName: state.purchase.cash.holderName,
        holderCpf: state.purchase.cash.holderCpf,
    }),
    {
        changeCashAttr
    }
)(Cash))



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/Cash.jsx